import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private modalSubject = new Subject<any>();
  private confirmSubject = new Subject<any>();

  modalState$ = this.modalSubject.asObservable();
  confirmAction$ = this.confirmSubject.asObservable(); // Observable para ações de confirmação

  constructor() {}

  open(modalId: string) {
    console.log(`Opening modal with ID: ${modalId}`); // Log para depuração
    this.modalSubject.next({ action: 'open', id: modalId });
  }

  close(modalId: string) {
    this.modalSubject.next({ action: 'close', id: modalId });
  }

  confirmAction(data: any) {
    this.confirmSubject.next(data); // Emite a ação de confirmação
  }
}